import IconButton from '@mui/material/IconButton';
import styled, { css } from 'styled-components';

import colors from 'app/styles/theme/colors';
import { StyledDialog as BaseStyledDialog } from 'app/components/StyledDialog/styles';
import { dialogPaper } from 'app/components/DialogFrame/styles';

export {
  Head,
  Title,
  Description,
  Body,
  Foot,
  ResultState,
  ResultIcon,
  ResultTitle,
  ResultMessage,
} from 'app/components/DialogFrame/styles';
export { SecondaryButton, PrimaryButton } from 'app/components/DialogFooterButtons/styles';

const { gray, green } = colors.designSystem;

export const StyledDialog = styled(BaseStyledDialog)`
  .MuiDialog-paper {
    width: 1040px;
    ${dialogPaper}
  }
`;

export const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const HeaderIconButton = styled(IconButton)`
  color: ${gray[700]} !important;
  padding: 4px !important;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const LoadingState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 240px;
`;

export const TableScrollContainer = styled.div`
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  margin-top: 8px;

  th,
  td {
    padding: 12px 16px;
    text-align: left;
    border-bottom: 1px solid ${gray[200]};
  }

  th:first-child,
  td:first-child {
    width: 34%;
  }
`;

export const PlanHeaderCell = styled.th<{ $highlighted?: boolean }>`
  text-align: center;
  vertical-align: top;
  font-weight: 600;
  background-color: ${gray[100]};

  ${({ $highlighted }) =>
    $highlighted &&
    css`
      background-color: ${green[100]};
    `}
`;

export const PlanName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${gray[950]};
`;

export const PlanPrice = styled.div`
  margin-top: 2px;
  font-size: 13px;
  font-weight: 400;
  color: ${gray[700]};
`;

export const Pill = styled.span<{ $variant: 'current' | 'popular' }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 500;
  background-color: ${({ $variant }) => ($variant === 'popular' ? green[100] : gray[200])};
  color: ${({ $variant }) => ($variant === 'popular' ? green[700] : gray[800])};
`;

export const Cell = styled.td<{ $highlighted?: boolean; $muted?: boolean }>`
  text-align: center;
  color: ${({ $muted }) => ($muted ? gray[500] : 'inherit')};

  ${({ $highlighted }) =>
    $highlighted &&
    css`
      background-color: ${green[100]};
    `}
`;

const ctaButton = css`
  width: 100%;
  padding: 10px 16px;
  border-radius: 7px;
  border: 1px solid transparent;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  @media (prefers-reduced-motion: no-preference) {
    transition: 120ms ease;
  }
`;

export const CtaButton = styled.button<{ $primary?: boolean }>`
  ${ctaButton}
  background-color: ${({ $primary }) => ($primary ? green[500] : 'transparent')};
  color: ${({ $primary }) => ($primary ? gray[0] : gray[800])};
  border-color: ${({ $primary }) => ($primary ? 'transparent' : gray[400])};

  &:hover,
  &:focus-visible {
    background-color: ${({ $primary }) => ($primary ? green[700] : gray[100])};
  }
`;

export const DisabledCtaButton = styled.button`
  ${ctaButton}
  background-color: ${gray[500]};
  color: ${gray[200]};
  cursor: not-allowed;
`;
